import { Box, Message } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { BASE_COMPOSITION, useBaseCompositionStore } from "./BaseCompositionStore";


const ErrorMessageBanners: FunctionComponent = observer(() => {
	const {
		currentBannerConditions,
		loc,
	} = useBaseCompositionStore();
	return (
		<>
			{currentBannerConditions.length > 0 && (
				<Box>
					{currentBannerConditions.map(({ sreName, bannerTitle }, index) => (
						<Message
							key={index}
							sx={{ marginTop: "-10px", marginX: "-25px" }}
							titleRes={bannerTitle}
							titleResParams={[sreName === BASE_COMPOSITION ? loc.resource("BaseComposition") : sreName]}
							variant="banner"
						/>
					))}
				</Box>
			)
			}
		</>
	);
},
);

export default ErrorMessageBanners;